// extracted by mini-css-extract-plugin
export default {"content":"_2a98y","link":"MdQTi"};